import { useContext } from "react";

import { isSelfService } from "@/lib/auth/rbac";
import { UserContext } from "@/lib/contexts/userContext";

export function useIsSelfService() {
  const { ownUser, applicationUser } = useContext(UserContext);

  return isSelfService(ownUser, applicationUser);
}
